<template>
    <div>
        <div class="filter-actions in-tab">
            <b-button v-if="canEdit" variant="success" @click="openAddModal">
                <i class="icon icon-plus-circle"></i> {{ label('Добавить объект', 'Объект қосу') }}
            </b-button>
        </div>

        <div class="filter-container">
            <b-dropdown class="filter-dropdown" variant="default" ref="drop">
                <template #button-content>
                    <span class="lc"><i class="icon icon-filter"></i>{{ label('Фильтр', 'Сүзгі') }}</span>
                    <span class="rc"><i class="icon icon-keyboard"></i></span>
                </template>
                <div>
                    <div class="top-content">
                        <span>{{ label('Параметры фильтра', 'Сүзгі параметрлері') }}</span>
                        <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                    </div>
                    <div class="filter-block owner-type-block">
                        <b-form-radio v-model="tempOwnerType" name="owner-type" value="gu">{{ label('ГУ', 'ММ') }}</b-form-radio>
                        <b-form-radio v-model="tempOwnerType" name="owner-type" value="gkkp">{{ label('КГКП', 'КМҚК') }}</b-form-radio>
                    </div>
                    <div class="filter-block">
                        <b-form-group :label="label('Регион', 'Өңір')">
                            <multiselect
                                v-model="tempSelectedRegion"
                                :options="regionOptions"
                                label="text"
                                track-by="code"
                                :allow-empty="false"
                                :show-labels="false"
                                :placeholder="label('Выбрать', 'Таңдаңыз')"
                            >
                                <span slot="noResult">{{ label('Ничего не найдено. Измените условия поиска.', 'Ештеңе табылмады. Іздеу шарттарын өзгертіңіз.') }}</span>
                                <span slot="noOptions">{{ label('Список пуст.', 'Тізім бос.') }}</span>
                            </multiselect>
                        </b-form-group>
                    </div>
                    <div class="filter-block">
                        <b-form-group :label="label('АБП', 'ББӘ')">
                            <multiselect
                                :value="abpOptions.length ? tempSelectedAbp : null"
                                @input="tempSelectedAbp = $event"
                                :options="abpOptions"
                                label="text"
                                track-by="code"
                                :allow-empty="false"
                                :show-labels="false"
                                :placeholder="label('Выбрать', 'Таңдаңыз')"
                            >
                                <span slot="noResult">{{ label('Ничего не найдено. Измените условия поиска.', 'Ештеңе табылмады. Іздеу шарттарын өзгертіңіз.') }}</span>
                                <span slot="noOptions">{{ label('Список пуст.', 'Тізім бос.') }}</span>
                            </multiselect>
                        </b-form-group>
                    </div>
                    <div class="filter-block">
                        <b-form-group :label="balanceHolderLabel">
                            <multiselect
                                :value="guListOption.length ? tempSelectedGu : null"
                                @input="tempSelectedGu = $event"
                                :options="guListOption"
                                label="text"
                                track-by="code"
                                :allow-empty="false"
                                :show-labels="false"
                                :placeholder="label('Выбрать', 'Таңдаңыз')"
                            >
                                <span slot="noResult">{{ label('Ничего не найдено. Измените условия поиска.', 'Ештеңе табылмады. Іздеу шарттарын өзгертіңіз.') }}</span>
                                <span slot="noOptions">{{ label('Список пуст.', 'Тізім бос.') }}</span>
                            </multiselect>
                        </b-form-group>
                    </div>
                    <div class="filter-block">
                        <b-form-group :label="label('Инвентарный номер', 'Түгендеу нөмірі')">
                            <b-form-input v-model="tempInvNumber" :placeholder="label('Ввести значение', 'Мәнді енгізіңіз')" />
                        </b-form-group>
                    </div>
                    <div class="filter-block">
                        <b-form-group :label="label('Вид актива', 'Актив түрі')">
                            <multiselect
                                v-model="selectedType"
                                :options="assetTypeOptions"
                                label="name"
                                track-by="code"
                                :allow-empty="false"
                                :show-labels="false"
                                :placeholder="label('Выбрать', 'Таңдаңыз')"
                            >
                                <span slot="noResult">{{ label('Ничего не найдено. Измените условия поиска.', 'Ештеңе табылмады. Іздеу шарттарын өзгертіңіз.') }}</span>
                                <span slot="noOptions">{{ label('Список пуст.', 'Тізім бос.') }}</span>
                            </multiselect>
                        </b-form-group>
                    </div>
                    <div class="filter-block">
                        <b-form-group :label="label('Подвид актива', 'Актив кіші түрі')">
                            <multiselect
                                v-model="selectedSubtype"
                                :options="subtypeList"
                                label="name"
                                track-by="code"
                                :allow-empty="false"
                                :show-labels="false"
                                :placeholder="label('Выбрать', 'Таңдаңыз')"
                            >
                                <span slot="noResult">{{ label('Ничего не найдено. Измените условия поиска.', 'Ештеңе табылмады. Іздеу шарттарын өзгертіңіз.') }}</span>
                                <span slot="noOptions">{{ label('Список пуст.', 'Тізім бос.') }}</span>
                            </multiselect>
                        </b-form-group>
                    </div>
                    <div class="filter-block">
                        <b-form-group :label="label('Статус объекта', 'Объект мәртебесі')">
                            <multiselect
                                v-model="tempSelectedStatus"
                                :options="statusOptions"
                                label="name"
                                track-by="code"
                                :allow-empty="false"
                                :show-labels="false"
                            >
                                <span slot="noResult">{{ label('Ничего не найдено. Измените условия поиска.', 'Ештеңе табылмады. Іздеу шарттарын өзгертіңіз.') }}</span>
                                <span slot="noOptions">{{ label('Список пуст.', 'Тізім бос.') }}</span>
                            </multiselect>
                        </b-form-group>
                    </div>
                    <div class="filter-block">
                        <b-form-group :label="label('Адрес', 'Мекенжай')">
                            <b-form-input v-model="tempAddress" :placeholder="label('Ввести значение', 'Мәнді енгізіңіз')" />
                        </b-form-group>
                    </div>
                </div>
                <div class="filter-block" style="margin-top: 30px">
                    <b-button variant="primary" @click="applyFilter">{{ label('Применить', 'Қолдану') }}</b-button>
                    <b-button variant="secondary" @click="resetFilter">{{ label('Сбросить', 'Ысыру') }}</b-button>
                </div>
            </b-dropdown>

            <div class="filter-breadcrumb" style="flex: 1">
                <span class="item-breadcrumb" v-if="appliedCrumbs.region" @click="openFilterByRef()">
                    {{ appliedCrumbs.region }}
                </span>
                <span class="item-breadcrumb" v-if="appliedCrumbs.abp" @click="openFilterByRef()">
                    {{ appliedCrumbs.abp }}
                </span>
                <span class="item-breadcrumb" v-if="appliedCrumbs.gu" @click="openFilterByRef()">
                    {{ appliedCrumbs.gu }}
                </span>
            </div>
        </div>

        <div class="table-container">
            <b-table
                class="table b-table table-bordered b-table-no-border-collapse"
                :fields="assetTableFields"
                :items="assetList"
                :tbody-tr-class="rowClass"
                @row-clicked="onRowClick"
            >
                <template #cell(status)="data">
                    <span
                        class="status-pill"
                        :class="data.item.status === 'active' ? 'status-pill--active' : 'status-pill--archive'"
                    >
                        {{ data.item.status === 'active' ? label('Активный', 'Белсенді') : label('Архивный', 'Мұрағаттағы') }}
                    </span>
                </template>
                <template #cell(extra)="data">
                    <b-dropdown dropleft class="more">
                        <template #button-content><i class="icon icon-more"></i></template>
                        <b-dropdown-item v-if="canEdit && data.item.status === 'active'" @click="editAsset(data.item)">{{ label('Редактировать', 'Өңдеу') }}</b-dropdown-item>
                        <b-dropdown-item v-if="canEdit" class="remove">{{ label('Исключить', 'Тізілімнен шығару') }}</b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>
            <div class="registry-footer">
                <!-- RQ.eAk.ASSETS.02.04.02–03: счётчик по всем страницам отбора, слева, на одной строке с пагинацией -->
                <div class="registry-counter">{{ label('Найдено', 'Табылды') }}: {{ total }}</div>
                <!-- RQ.eAk.ASSETS.02.04.01: страницы по 50 записей, переход по номерам -->
                <b-pagination
                    v-model="currentPage"
                    :total-rows="total"
                    :per-page="pageSize"
                    class="m-0"
                    @change="onPageChange"
                ></b-pagination>
                <div class="registry-footer-spacer"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: 'ObjectsRegistry',
    components: {
        multiselect: Multiselect
    },
    data() {
        return {
            assetList: [],
            total: 0,
            currentPage: 1,
            pageSize: 50,
            regionList: [],
            // АБП и балансодержатели пользователя по типу балансодержателя; грузятся сразу оба,
            // переключатель ГУ / КГКП только выбирает нужный набор
            ownerLists: {
                gu: { abpList: [], guList: [] },
                gkkp: { abpList: [], guList: [] }
            },
            allAssetSubtypes: [],

            // ГУ / КГКП — переключатель типа балансодержателя в фильтре
            tempOwnerType: 'gu',
            tempSelectedRegion: this.allOption(),
            tempSelectedAbp: this.allOption(),
            tempSelectedGu: this.allOption(),
            tempInvNumber: '',
            tempSelectedAssetSubtype: null,
            tempSelectedStatus: this.allOption(),
            tempAddress: '',

            // query-параметры последнего применённого фильтра — по ним грузится реестр
            appliedParams: 'owner_type=gu',
            ownerType: 'gu',
            selectedAbp: null,
            selectedGu: null,
            selectedRegion: null,
            assetTypeList: [],
            selectedType: this.allOption(),
            selectedSubtype: this.allOption(),

            // уровень доступа к модулю «Реестр госактивов» (003.010): 1 — просмотр, 2/3 — создание и правка, 4 — ещё и удаление
            access_level: 1,
        };
    },
    computed: {
        canEdit() {
            return this.access_level >= 2;
        },
        // крошки — только применённый отбор (RQ.eAk.ASSETS.02.03.03), а не черновик фильтра (02.03.01);
        // названия берутся по кодам из перечней на текущем языке, чтобы переживать смену языка
        appliedCrumbs() {
            const crumbs = { region: '', abp: '', gu: '' };
            const lists = this.ownerLists[this.ownerType] || { abpList: [], guList: [] };
            const nameOf = (rec) => this.label(rec.name_ru || rec.name_kk, rec.name_kk || rec.name_ru);
            if (!this.isAll(this.selectedRegion)) {
                const reg = (this.regionList || []).find(r => r.code === this.selectedRegion.code);
                if (reg) crumbs.region = nameOf(reg);
            }
            if (!this.isAll(this.selectedAbp)) {
                const abp = lists.abpList.find(a => a.code === this.selectedAbp.code);
                if (abp) crumbs.abp = `${abp.code} - ${nameOf(abp)}`;
            }
            if (!this.isAll(this.selectedGu)) {
                const gu = lists.guList.find(g => g.code === this.selectedGu.code);
                if (gu) crumbs.gu = `${gu.code} - ${nameOf(gu)}`;
            }
            return crumbs;
        },
        // одно поле без указания типа в подписи (UC.eAk.ASSETS.02, раздел 4.1)
        balanceHolderLabel() {
            return this.label('Балансодержатель', 'Баланс ұстаушы');
        },
        statusOptions() {
            return [
                this.allOption(),
                { code: 'active', name: this.label('Активный', 'Белсенді') },
                { code: 'archive', name: this.label('Архивный', 'Мұрағаттағы') }
            ];
        },
        assetTableFields() {
            return [
                { key: 'invNumber', label: this.label('Инв. №', 'Түг. №') },
                { key: 'name', label: this.label('Наименование', 'Атауы') },
                { key: 'abp', label: this.label('АБП', 'ББӘ') },
                {
                    key: 'balanceHolder',
                    label: this.label('Балансодержатель', 'Баланс ұстаушы'),
                    formatter: (_, __, item) => `${item.guCode} - ${this.label(item.guName, item.guNameKk || item.guName)}`
                },
                {
                    key: 'region',
                    label: this.label('Регион', 'Өңір'),
                    // наименование КАТО без кода — из списка регионов фильтра (regionList)
                    formatter: (_, __, item) => {
                        const reg = (this.regionList || []).find(r => r.code === item.regionCode);
                        if (!reg) return '';
                        return this.$i18n.locale === 'kk' ? (reg.name_kk || reg.name_ru) : (reg.name_ru || reg.name_kk);
                    }
                },
                { key: 'status', label: this.label('Статус', 'Мәртебесі') },
                {
                    key: 'acceptedDate',
                    label: this.label('Дата принятия на баланс', 'Балансқа қабылдау күні'),
                    // бэк отдаёт ISO (ГГГГ-ММ-ДД), на экране — ДД.ММ.ГГГГ
                    formatter: (value) => (value ? String(value).slice(0, 10).split('-').reverse().join('.') : '')
                },
                { key: 'extra', label: '' }
            ];
        },
        // перечни атрибутов фильтра с пунктом «Все» первым (RQ.eAk.ASSETS.02.02.08)
        regionOptions() {
            return [
                this.allOption(),
                ...(this.regionList || []).map((reg) => ({
                    ...reg,
                    text: this.label(reg.name_ru || reg.name_kk, reg.name_kk || reg.name_ru)
                }))
            ];
        },
        abpList() {
            return this.ownerLists[this.tempOwnerType].abpList.map(rec => {
                const name = this.label(rec.name_ru || rec.name_kk, rec.name_kk || rec.name_ru);
                return { code: rec.code, name, text: `${rec.code} - ${name}` };
            });
        },
        guList() {
            return this.ownerLists[this.tempOwnerType].guList;
        },
        // нет ни одного АБП в скоупе — перечень пуст, «Все» не выводим (RQ.eAk.ASSETS.02.06.04)
        abpOptions() {
            return this.abpList.length ? [this.allOption(), ...this.abpList] : [];
        },
        assetTypeOptions() {
            return [
                this.allOption(),
                ...this.assetTypeList.map(rec => ({
                    code: rec.code,
                    name: this.label(rec.name_ru || rec.name_kk, rec.name_kk || rec.name_ru)
                }))
            ];
        },
        // при виде «Все» — все подвиды (RQ.eAk.ASSETS.02.02.04)
        subtypeList() {
            const subtypes = this.isAll(this.selectedType)
                ? (this.allAssetSubtypes || [])
                : (this.allAssetSubtypes || []).filter((st) => st.type_code === this.selectedType.code);
            return [
                this.allOption(),
                ...subtypes.map((st) => ({
                    code: st.code,
                    name: this.$i18n.locale === 'kk'
                        ? (st.name_kk || st.name_ru)
                        : (st.name_ru || st.name_kk)
                }))
            ];
        },
        // при АБП «Все» — все балансодержатели из скоупа пользователя
        guListOption() {
            const guList = this.isAll(this.tempSelectedAbp)
                ? this.guList
                : this.guList.filter(item => item.abp === this.tempSelectedAbp.code);
            if (!guList.length) return [];
            return [
                this.allOption(),
                ...guList.map(item => ({
                    code: item.code,
                    name: this.$i18n.locale === 'kk' ? (item.name_kk || item.name_ru) : (item.name_ru || item.name_kk),
                    text: `${item.code} - ${this.$i18n.locale === 'kk' ? (item.name_kk || item.name_ru) : (item.name_ru || item.name_kk)}`
                }))
            ];
        },
    },
    watch: {
        // реестр остаётся смонтированным под карточкой (фильтр сохраняется, RQ.eAk.ASSETS.02.03.05) —
        // при возврате перечитываем список по применённому фильтру
        '$route.name'(name) {
            if (name === 'register-assets') this.loadAssetCardList();
        },
        // при смене вида актива в фильтре сбрасываем ранее выбранный подвид в «Все»,
        // т.к. он может не принадлежать новому type_code (RQ.eAk.ASSETS.02.02.04.01)
        selectedType() {
            this.selectedSubtype = this.allOption();
        },
        // выбранные значения хранят объект опции со старым языком — после смены языка подставляем
        // опцию с тем же code из пересобранных перечней (RQ.eAk.ASSETS.02.06.02); значения фильтра сохраняются
        '$i18n.locale'() {
            const pick = (options, current) => options.find(o => o.code === current.code) || this.allOption();
            const gu = this.tempSelectedGu;
            const subtype = this.selectedSubtype;
            this.tempSelectedRegion = pick(this.regionOptions, this.tempSelectedRegion);
            this.tempSelectedStatus = pick(this.statusOptions, this.tempSelectedStatus);
            this.tempSelectedAbp = pick(this.abpOptions, this.tempSelectedAbp);
            this.selectedType = pick(this.assetTypeOptions, this.selectedType);
            // watch-и выше сбрасывают балансодержателя и подвид при смене АБП / вида — возвращаем их после сброса
            this.$nextTick(() => {
                this.tempSelectedGu = pick(this.guListOption, gu);
                this.selectedSubtype = pick(this.subtypeList, subtype);
            });
        },
        // при смене АБП или типа балансодержателя сбрасываем балансодержателя в «Все»
        // (RQ.eAk.ASSETS.02.02.03.01)
        tempSelectedAbp() {
            this.tempSelectedGu = this.allOption();
        },
        // АБП сохраняем, если он есть и в списке нового типа, иначе — «Все»
        tempOwnerType() {
            if (!this.abpList.some(abp => abp.code === this.tempSelectedAbp.code)) {
                this.tempSelectedAbp = this.allOption();
            }
            this.tempSelectedGu = this.allOption();
        }
    },
    async created() {
        await this.getAccessLevel();
        await this.loadAssetTypeList();
        await this.loadAssetCardList();
        // область инстанса нужна перечням АБП / ГУ / КГКП — у консультанта они иначе собираются по всей РК (RQ.eAk.ASSETS.02.01.03)
        await this.getObl();
        await this.loadAbpList('gu');
        await this.loadAbpList('gkkp');
    },
    methods: {
        label(ru, kk) {
            return this.$i18n.locale === 'kk' ? kk : ru;
        },
        async getAccessLevel() {
            try {
                const response = await fetch(`/api-py/user-modules/${this.$store.getters.user_uuid}/003.010`);
                const modules_access = await response.json();
                if (modules_access.length > 1) {
                    this.makeToast('danger', 'Ошибка', 'У пользователя несколько записей');
                }
                // при нескольких записях берём максимальный уровень; без записи — просмотр
                this.access_level = modules_access.length
                    ? Math.max(...modules_access.map(ma => ma.access_level))
                    : 1;
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса load_user_access_level', error.toString());
            }
        },
        makeToast(variant, title, tostbody) {
            this.$root.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },
        // пункт «Все» для выпадающих списков фильтра: name — для label="name", text — для label="text"
        allOption() {
            const title = this.label('Все', 'Барлығы');
            return { code: 'all', name: title, text: title };
        },
        isAll(option) {
            return !option || option.code === 'all';
        },
        async loadAssetTypeList() {
            try {
                const response = await fetch('/api-py/get_dict_asset_type');
                if (response.status === 200) {
                    const records = await response.json();
                    // имена на обоих языках — подпись на языке интерфейса строится в computed
                    this.assetTypeList = records.asset_type || [];
                    this.allAssetSubtypes = records.asset_subtype || [];
                }
            } catch (error) {
                this.assetTypeList = [];
                this.allAssetSubtypes = [];
            }
        },
        async getObl() {
            try {
                await fetch('/api-py/get-budget-obl/' + this.$store.state._instanceCode)
                    .then(response => response.json())
                    .then(json => {
                        this.obl = json.obl;
                    });

            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса getObl', error.toString());
            }
            try {
                const response = await fetch('/api-py/get_region_from_dict_kato_stat/' + this.obl);
                this.regionList = await response.json();
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса getObl', error.toString());
            }
        },
        // ownerType: 'gu' | 'gkkp' — какой набор АБП и балансодержателей загрузить
        async loadAbpList(ownerType) {
            try {
                const response = await fetch('/api-py/get_abp_by_user_gu_gkkp/' + ownerType + '/' + this.$store.getters.user_uuid
                    + (this.obl ? '?obl=' + encodeURIComponent(this.obl) : ''));
                if (response.status === 200) {
                    const records = await response.json();
                    this.ownerLists[ownerType] = {
                        abpList: (records.abp_list || []).map(rec => ({
                            code: rec.abp,
                            name_ru: rec.name_ru,
                            name_kk: rec.name_kk
                        })),
                        guList: records.gu_gkkp_list || []
                    };
                }
            } catch (error) {
                this.ownerLists[ownerType] = { abpList: [], guList: [] };
            }
        },
        async loadAssetCardList() {
            try {
                const response = await fetch('/api-py/get_asset_card_list?' + this.appliedParams
                    + '&user_id=' + this.$store.getters.user_uuid
                    + '&page=' + this.currentPage + '&size=' + this.pageSize);
                if (response.status === 200) {
                    const data = await response.json();
                    this.assetList = data.items || [];
                    this.total = data.total || 0;
                }
            } catch (error) {
                this.assetList = [];
                this.total = 0;
            }
        },
        onPageChange(page) {
            this.currentPage = page;
            this.loadAssetCardList();
        },
        rowClass(item) {
            return [item && item.status === 'archive' ? 'table-secondary' : '', 'row-clickable'];
        },
        // RQ.eAk.ASSETS.02.05.01: клик в любом месте строки открывает карточку, кроме меню действий
        onRowClick(item, index, event) {
            if (event && event.target && event.target.closest('.more')) return;
            this.openAsset(item);
        },
        openFilterByRef() {
            this.$refs.drop.show(true);
        },
        // собирает query-параметры из текущих значений фильтра; «Все» и пустые поля не передаются
        buildFilterParams() {
            const params = new URLSearchParams();
            params.append('owner_type', this.tempOwnerType);
            if (!this.isAll(this.tempSelectedRegion)) params.append('region_code', this.tempSelectedRegion.code);
            if (!this.isAll(this.tempSelectedAbp)) params.append('abp', this.tempSelectedAbp.code);
            if (!this.isAll(this.tempSelectedGu)) params.append('balanceholder', this.tempSelectedGu.code);
            if (this.tempInvNumber.trim()) params.append('inv_number', this.tempInvNumber.trim());
            if (!this.isAll(this.selectedType)) params.append('asset_type', this.selectedType.code);
            if (!this.isAll(this.selectedSubtype)) params.append('subtype', this.selectedSubtype.code);
            if (!this.isAll(this.tempSelectedStatus)) params.append('status', this.tempSelectedStatus.code);
            if (this.tempAddress.trim()) params.append('address', this.tempAddress.trim());
            return params.toString();
        },
        applyFilter() {
            this.ownerType = this.tempOwnerType;
            this.selectedRegion = this.tempSelectedRegion;
            this.selectedAbp = this.tempSelectedAbp;
            this.selectedGu = this.tempSelectedGu;
            this.appliedParams = this.buildFilterParams();
            this.currentPage = 1;
            this.loadAssetCardList();
            this.$refs.drop.hide(true);
        },
        resetFilter() {
            this.tempOwnerType = 'gu';
            this.tempSelectedRegion = this.allOption();
            this.tempSelectedAbp = this.allOption();
            this.tempSelectedGu = this.allOption();
            this.tempInvNumber = '';
            this.selectedType = this.allOption();
            this.selectedSubtype = this.allOption();
            this.tempSelectedStatus = this.allOption();
            this.tempAddress = '';
            // «Сбросить» обновляет реестр по значениям по умолчанию (RQ.eAk.ASSETS.02.03.02)
            this.ownerType = this.tempOwnerType;
            this.selectedRegion = this.tempSelectedRegion;
            this.selectedAbp = this.tempSelectedAbp;
            this.selectedGu = this.tempSelectedGu;
            this.appliedParams = this.buildFilterParams();
            this.currentPage = 1;
            this.loadAssetCardList();
        },
        openAddModal() {
            this.$router.push({ name: 'register-assets-card' });
        },
        openAsset(item) {
            this.$router.push({ name: 'register-assets-card', params: { id: item.id } });
        },
        // карточка сразу в режиме редактирования; from=registry — после сохранения / «Назад» вернуться в реестр
        editAsset(item) {
            this.$router.push({ name: 'register-assets-card', params: { id: item.id }, query: { mode: 'edit', from: 'registry' } });
        },
        // excludeAsset(item) {
        //     // TODO: уточнить у analyst-budget семантику «Исключить» — мягкое исключение
        //     // (статус «Архивный») или физическое удаление записи реестра
        //     item.status = 'archive';
        // }
    }
};
</script>

<style scoped>
/* кнопка «Добавить объект» (общий z-index 1020) не должна перекрывать панель инструкций/выгрузки (1008) и меню пользователя */
.filter-actions.in-tab {
    z-index: 1007;
}
/* Sticky-шапка без обёртки-скролла: липнет к верху прокручиваемой области страницы, футер остаётся в потоке после таблицы */
.table-container ::v-deep .table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
}
.registry-footer {
    display: flex;
    align-items: center;
    margin-top: 16px;
}
.registry-counter,
.registry-footer-spacer {
    flex: 1;
}
.registry-counter {
    font-size: 15px;
}
.row-clickable {
    cursor: pointer;
}
.status-pill {
    display: inline-block;
    padding: 3px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
}

.owner-type-block {
    display: flex;
    gap: 30px;
}

.status-pill--active {
    background-color: #fff;
    border: 1px solid #2196F3;
    color: #2196F3;
}

.status-pill--archive {
    background-color: #fff;
    border: 1px solid #7C9DB3;
    color: #7C9DB3;
}
</style>
